var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIRepeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28.552 28.538",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "repeat",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M5.017,14.378A9.3,9.3,0,0,1,17.93,5.747L16.01,7.668l10.206,2.6L23.615.062,21.634,2.043A14.261,14.261,0,0,0,.032,13.629L0,14.335l5.026,1.088Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M61.91,238.325a9.316,9.316,0,0,1-9.252,9.252,9.452,9.452,0,0,1-3.645-.729l1.853-1.854-10.21-2.624,2.625,10.208,2.006-2.006a14.44,14.44,0,0,0,7.371,2.021,14.267,14.267,0,0,0,14.235-13.577l.034-.707-5.016-1.021Zm0,0",
    transform: "translate(-38.388 -224.056)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIRepeat);
export default __webpack_public_path__ + "static/media/i-repeat.a64c06d3cbcb1e31dd6ddc251e8d1f0a.svg";
export { ForwardRef as ReactComponent };